<bl-modal-content #content
  [title]="'送信する条件の確認'"
  [footerButtonType]="footerButtonType"
  [okButtonSetting]="okButtonSetting"
  [cancelButtonSetting]="cancelButtonSetting"
  [disableOkButton]="!isExistMessage"
>
  <div body>
    <div *ngIf="isDispNoteMessage" class="description">
      <span class="icon-icon_alert notice_alert"></span>複数の友だちに一斉送信します。内容に間違いがないかご注意ください。</div>
    <div *ngIf="isExistMessage" class="preview">
      <share-line-message-list-viewer
        [contentHorizontalAlignment]="'left'"
        [messageObjectStrings]="_previewMessages"
      ></share-line-message-list-viewer>
    </div>
    <div *ngIf="!isExistMessage" class="empty">
      <div>
        メッセージのプレビューに失敗しました。<br>
        時間をおいて再度お試しください。
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.component.html